module.exports = __webpack_public_path__ + "static/media/03 Product.40541411.png";